export const folderIcon = "<span class='webix_icon wxi-folder'></span>";
export const backIcon =
	"<span class='webix_icon wxi-angle-double-left'></span>";
export const menuIcon = "<span class='webix_icon wxi-dots'></span>";

export const checkedIcon =
	"<span class='webix_icon wxi-checkbox-marked'></span>";
export const notCheckedIcon =
	"<span class='webix_icon wxi-checkbox-blank'></span>";

export const checkedIconAlt =
	"<span class='webix_icon wxi-check'></span>";
export const notCheckedIconAlt =
	"<span class='webix_icon wxi-minus '></span>";
